import { z } from "zod/v4"

z.config({
  // MYVC-40096: avoid CSP errors in Firefox
  jitless: true,
})
